import { deleteWithAuth } from "protocol-setup/redux/makeFetch";
import { deleteFilePath } from "protocol-setup/redux/constants";

/**
 * Calculates which files should be deleted by comparing current files with initial files.
 * @param {Array} currentFiles - The list of files currently attached in the form.
 * @param {Array} initialFiles - The list of files originally retrieved from the server.
 * @returns {Array} - The list of files that are present in initialFiles but not in currentFiles (matched by name).
 */
export const calculateFilesToDelete = (currentFiles = [], initialFiles = []) => {
  if (!initialFiles || initialFiles.length === 0) {
    return [];
  }

  const newFileNames = currentFiles.map((f) => f.name);
  return initialFiles.filter((f) => !newFileNames.includes(f.name));
};

/**
 * Deletes the specified files from the server.
 * @param {Array} filesToDelete - The list of files to delete.
 * @returns {Promise<PromiseSettledResult<any>[]>} - A promise that resolves when all delete operations are settled.
 */
export const handleFileDeletions = (filesToDelete = []) => {
  if (!filesToDelete || filesToDelete.length === 0) {
    return Promise.resolve([]);
  }

  return Promise.allSettled(
    filesToDelete.map((f) => {
      // Assuming f.id or f.fileId is the identifier. 
      // In RegulatorySetupForm it was f.id. 
      // Let's verify what the object structure usually is. 
      // Standardizing on 'id' as per RegulatorySetupForm usage.
      return deleteWithAuth(deleteFilePath(f.id));
    })
  );
};
